module.exports = __webpack_public_path__ + "img/spirit_1248.98873af8.png";